import React, { type FC } from "react";

import { Pill } from "./styled-components";

import type { SCPillProps } from "./types";

export const SegmentedControlPill: FC<SCPillProps> = ({
  qaLabel = "segmented-control-pill"
}) => <Pill className="segmented-control-pill" data-qa-label={qaLabel} />;
